import React from 'react';
import { RoomsPreloadCacheProvider } from './RoomsPreloadCacheProvider';

export const RoomsProviders = ({ children }: any) => {
	return <RoomsPreloadCacheProvider>{children}</RoomsPreloadCacheProvider>;
};
